var render = function render(){var _vm=this,_c=_vm._self._c;return _c('vx-card',{attrs:{"title":"Approval Credit Note"}},[_c('vs-tabs',[_c('vs-tab',{attrs:{"label":"Open"}},[_c('div',{staticClass:"tab-text"},[_c('open')],1)]),_c('vs-tab',{attrs:{"label":"Reversed"}},[_c('div',{staticClass:"tab-text"},[_c('reversed')],1)])],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }